import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { ContactForm } from '../models/contact.model'
import { AppConfigurationService } from './app-configuration.service'

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  constructor(
    private http: HttpClient,
    private appConfigurationService: AppConfigurationService
  ) {}

  public submitContact(contactForm: ContactForm): Observable<any> {
    const baseSiteUrl: string = this.appConfigurationService.getBaseSiteUrl()
    const postUrl = `${baseSiteUrl}/contactUs/create?fields=DEFAULT`
    return this.http.post(postUrl, contactForm).pipe(catchError(this.handleError))
  }

  private handleError(error: HttpErrorResponse): any {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message)
    } else {
      console.error(`Backend returned code ${error.status}, ` + `error: ${error.error}`)
    }
    return throwError('Error happened. please try again later.')
  }
}
